// project import
import { orgScopeSpecificItem, siteScopeSpecificItem, pages } from "./pages";

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [orgScopeSpecificItem, siteScopeSpecificItem, pages],
};

export default menuItems;
